import { Entry } from '../Entry'

export function Entry20230125() {
  return (
    <Entry title="25/01/2023 - v3.3.2">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13531/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
